import { Injectable, Inject } from '@angular/core';
import { HttpService, AuthenticationService } from 'ew-common-lib';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TableListApiUrls } from './constants/api-urls';

@Injectable({
  providedIn: 'root'
})

export class EwMaTableListService {
  /**
   * @description
   * API token for authentication.
   */
  private token: string;
  public environment: any;

  /**
   * @description
   * Event id to use in the library
   */
  public eventId: string;

  public evenstsCount: BehaviorSubject<Record<string, any>> = new BehaviorSubject(null);

  /**
   * @description
   * Inject services to use in this component.
   * @param env environment file for API base URLs.
   * @param httpService http service to call APIs.
   * @param authenticationService To get auth token.
   */
  constructor(
    @Inject('env') private env,
    private httpService: HttpService,
    private authenticationService: AuthenticationService
  ) {
    this.environment = env;
    this.token = this.authenticationService.getUserAccessToken();
  }
  
  /**
   * @description
   * Generates full url for API request.
   * @param url Resource name
   */
  getUrl(url: string) {
    return this.environment.apiBaseUrl + url;
  }

  getESUrl(url: string) {
    return this.environment.ECEndpoint + url;
  }
  
  /**
   * @description
   * V2 CDN
   * @param url Resource name
   */
   getV2CDN() {
    return this.environment.V2CDN;
  }
  /**
   * @description
   * Service to fetch webinars list
   * @returns API response as observable.
   */
  getWebinars(model: any) {
  let url = this.getUrl(TableListApiUrls.v1.webinar_list);

  return this.httpService
    .get(this.token, url, model)
    .pipe(catchError(this.handleError<any>('getWebinars')));
  }

  /**
   * @description
   * Service to fetch Chat History/Question
   * @returns API response as observable.
   */
  getQuestions(model: any) {
    let url = this.getUrl(TableListApiUrls.v1.questions);

    return this.httpService
      .get(this.token, url, model)
      .pipe(catchError(this.handleError<any>('getQuestions')));
  }

  /**
   * @description
   * Service to fetch Session Listing
   * @returns API response as observable.
   */
  getSessionList(model: any) {
    let url = this.getUrl(TableListApiUrls.v1.session_list);
    url = url.replace('{id}', model.event_id);

    return this.httpService
      .get(this.token, url, model)
      .pipe(catchError(this.handleError<any>('getSessionList')));
  }

  /**
   * @description
   * Service to fetch Session Video Listing
   * @returns API response as observable.
   */
   getSessionVideoList(model: any) {
    let url = this.getUrl(TableListApiUrls.v1.session_video_list);
    url = url.replace('{id}', model.event_id);

    return this.httpService
      .get(this.token, url, model)
      .pipe(catchError(this.handleError<any>('getSessionVideoList')));
  }
  

  /**
   * @description
   * Service to fetch webinars list
   * @returns API response as observable.
   */
   getWebinarsES(model: any) {
    let url = this.getESUrl(TableListApiUrls.v1.es_webinar_endpoint);

    return this.httpService
      .post(this.token, url, model)
      .pipe(catchError(this.handleError<any>('getWebinarsES')));
  }

  /**
   * @description
   * Service to fetch webinars list
   * @returns API response as observable.
   */
   getOffers(model: any) {
    let url = this.getESUrl(TableListApiUrls.v1.es_offers_endpoint);

    return this.httpService
      .post(this.token, url, model)
      .pipe(catchError(this.handleError<any>('getOffers')));
  }
  

  /**
   * @description
   * Service to fetch webinars list
   * @returns API response as observable.
   */
  getPoll(model: any) {
    let url = this.getESUrl(TableListApiUrls.v1.es_poll_endpoint);

    return this.httpService
      .post(this.token, url, model)
      .pipe(catchError(this.handleError<any>('getPoll')));
  }

  /**
   * @description
   * Service to fetch attendees list
   * @returns API response as observable.
   */
   getAttendees(model: any) {
    let url = this.getESUrl(TableListApiUrls.v1.attendee_list);

    return this.httpService
      .post(this.token, url, model)
      .pipe(catchError(this.handleError<any>('getAttendees')));
  }

  

  /**
   * @description
   * Service to archive a webinar
   * @returns API response as observable.
   */
   archiveEvent(model: any) {
    let url = this.getUrl(TableListApiUrls.v1.archive_event);
    url = url.replace('{id}', model.webinar_id);
    return this.httpService
      .post(this.token, url, model)
      .pipe(catchError(this.handleError<any>('archiveEvent')));
  }
  /**
   * @description
   * Service to get the go live link for an event
   * @returns API response as observable.
   */
   goLive(model: any) {
    let url = this.getUrl(TableListApiUrls.v1.go_live);
    url = url.replace('{id}', model.webinar_id);
    delete model.webinar_id;
    return this.httpService
      .post(this.token, url, model)
      .pipe(catchError(this.handleError<any>('goLive')));
  }
  /**
   * @description
   * Service to get the go live link for an event
   * @returns API response as observable.
   */
   endOldAndGoLiveNew(model: any) {
    let url = this.getUrl(TableListApiUrls.v1.end_old_go_live_new);
    url = url.replace('{id}', model.webinar_id);
    delete model.webinar_id;
    return this.httpService
      .post(this.token, url, model)
      .pipe(catchError(this.handleError<any>('endOldAndGoLiveNew')));
  }

  hoa(model: any) {
    let url = this.getUrl(TableListApiUrls.v1.go_live_hoa);
    url = url.replace('{id}', model.webinar_id);
    delete model.webinar_id;
    return this.httpService
      .post(this.token, url, model)
      .pipe(catchError(this.handleError<any>('hoa')));
  }

  /**
   * @description
   * Service to fetch webinars list
   * @returns API response as observable.
   */
   getWebinarStats(model: any) {
    let url = this.getUrl(TableListApiUrls.v1.webinar_list);

    return this.httpService
      .get(this.token, url, model)
      .pipe(catchError(this.handleError<any>('getWebinars')));
  }
  /**
   * @description
   * Fetch event details from API
   * @param model Data to attach with API.
   */
   getWebinarDetails(model: any) {
    let url = this.getUrl(TableListApiUrls.v1.event_details_analytics);
    return this.httpService
      .get(this.token, url.replace('{id}', model.id) , model)
      .pipe(catchError(this.handleError<any>('getEventDetails')));
  }

  /**
   * @description
   * GET Images CDN endpoint.
   * 
   */
   getImageCDNEndpoint() {
    return this.env.imagesCDN;
  }

  /**
   * @description
   * Handle error
   * @param string operation
   * @param T result
   */
  handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
      if(error.error.code == 'rest_forbidden' || error.status==403){
        window.location.reload();
      }
     
      // Let the app keep running by returning an empty result.
      return throwError(error);
    };
  }

}
